// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__nglnq","filesListContainer":"PosDisputesFiles_filesListContainer__3CD1y","filesButton":"PosDisputesFiles_filesButton__1MuyC"};